/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'

export interface RcmTableDataContextValue {
  isGridView: boolean
  page: number
  hasNextPage: boolean
  defaultSortBy?: string | null
  defaultSortDesc?: boolean
  sortBy: string
  sortDesc: boolean
  entries: any[]
  total: number
  isLoading: boolean
  error: boolean
  persistenceKey: string | null
  filter: any
  isFilterCollapsed: boolean
  updateUrlPageParam: boolean
  load: (params: { sortDesc: boolean; sortBy: string; pageSize: number; pageStart: number }) => void
  setIsFilterCollapsed: (collapsed: boolean) => void
  applyFilter: (filter: any) => void
  setFilter: (filter: any) => void
  setIsGridView: (isGrid: boolean) => void
  setSort: (sortBy: string, sortDesc: boolean) => void
  refreshTable: (goToPage?: number | null, isSilent?: boolean, userId?: number | null) => void
}

export const RcmTableDataContext = React.createContext<RcmTableDataContextValue | null>(null)
